var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow
    },
    on: {
      "close": function ($event) {
        return _vm.changeToShow(false);
      }
    }
  }, [_vm.folders.length > 0 ? _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-36 2xl:my-18 2xl:mx-28 text-center"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("\n        Déplacer le " + _vm._s(_vm.filetype) + " « " + _vm._s(_vm.filename) + " »\n      ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.resetFolderSelection,
      expression: "resetFolderSelection"
    }],
    staticClass: "bg-white shadow rounded-xl"
  }, [_c('div', {
    staticClass: "py-6 px-16",
    attrs: {
      "id": "move_header"
    }
  }, [_c('div', {
    staticClass: "relative flex items-center mb-5"
  }, [_vm.currentFolder != null ? _c('div', {
    staticClass: "absolute -left-10 cursor-pointer",
    on: {
      "click": _vm.returnBack
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600 h-5 w-5",
    attrs: {
      "name": "arrow-circle-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h5', {
    staticClass: "text-left"
  }, [_vm._v("\n              " + _vm._s(_vm.currentFolder !== null ? _vm.folders.filter(function (f) {
    return f.id == _vm.currentFolder;
  })[0].name : 'Dépôt de documents') + "\n            ")])]), _vm._v(" "), _c('search-bar', {
    attrs: {
      "name": "searchFolder",
      "has-border": false,
      "placeholder": "Rechercher un dossier",
      "value": _vm.searchFolder,
      "has-suggestion": true
    },
    on: {
      "input": function (newValue) {
        _vm.searchFolder = newValue;
      },
      "displaySuggestionsList": function (state) {
        _vm.displaySuggestionsList(state);
      }
    },
    scopedSlots: _vm._u([_vm.isSuggestionsListDisplayed ? {
      key: "suggestionsList",
      fn: function () {
        return _vm._l(_vm.foldersFilter.filter(function (f) {
          return f.id != _vm.fileToMove.id && _vm.folders.filter(function (f2) {
            return f2.folder_id == f.id;
          }).length > 0;
        }), function (folder, kf) {
          return _c('div', {
            key: kf,
            staticClass: "h-20 cursor-default flex items-center space-x-3 px-6 bg-white bg-opacity-0 odd:bg-gray-200 odd:bg-opacity-50 hover:bg-indigo-200 hover:bg-opacity-100 odd:hover:bg-indigo-200 odd:hover:bg-opacity-100",
            on: {
              "click": function ($event) {
                $event.stopPropagation();
                _vm.currentFolder = folder.id;
                _vm.isSuggestionsListDisplayed = false;
              }
            }
          }, [_c('icon', {
            staticClass: "h-6 w-7",
            class: {
              'text-indigo-600': folder.color == 'indigo',
              'text-teal-600': folder.color == 'teal',
              'text-orange-600': folder.color == 'orange',
              'text-pink-600': folder.color == 'pink',
              'text-gray-600': folder.color == 'gray'
            },
            attrs: {
              "name": "folder"
            }
          }), _vm._v(" "), _c('p', {
            staticClass: "text-lg"
          }, [_vm._v("\n                  " + _vm._s(folder.name) + "\n                ")]), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: _vm.folders.filter(function (f) {
                return f.folder_id == folder.id;
              }).length > 0,
              expression: "\n                    folders.filter((f) => f.folder_id == folder.id).length > 0\n                  "
            }],
            staticClass: "text-base font-light italic text-gray-600"
          }, [_vm._v("\n                  " + _vm._s(_vm.folders.filter(function (f) {
            return f.folder_id == folder.id;
          }).length) + "\n                  Dossier" + _vm._s(_vm.folders.filter(function (f) {
            return f.folder_id == folder.id;
          }).length > 1 ? 's' : '') + "\n                ")])], 1);
        });
      },
      proxy: true
    } : null], null, true)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "border-t border-indigo-600"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listFolders"
    }
  }, [_vm.currentFolder == null && _vm.fileToMove.folder_id != null ? _c('div', {
    staticClass: "grid grid-cols-12 items-center h-20 px-6 hover:bg-indigo-200",
    class: {
      'bg-gray-200 odd:bg-white bg-opacity-50 odd:bg-opacity-0': _vm.selectedFolder != null,
      'bg-indigo-200': _vm.selectedFolder == null
    },
    on: {
      "click": function ($event) {
        return _vm.changeFolder({
          id: null,
          name: 'Dépôt de documents'
        });
      }
    }
  }, [_c('div', {
    staticClass: "col-span-8 flex text-left items-stretch space-x-3"
  }, [_c('icon', {
    staticClass: "h-6 w-7 text-gray-600",
    attrs: {
      "name": "folder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-3"
  }, [_c('p', {
    staticClass: "text-lg"
  }, [_vm._v("\n                  Mon dépôt de documents\n                ")])])], 1)]) : _vm._e(), _vm._v(" "), _vm._l(_vm.foldersCanEdit.filter(function (f) {
    return f.folder_id == _vm.currentFolder && f.id != _vm.fileToMove.id;
  }), function (folder, kf) {
    return _c('div', {
      key: kf,
      staticClass: "group cursor-default",
      class: {
        'bg-gray-200 odd:bg-white bg-opacity-50 odd:bg-opacity-0': _vm.selectedFolder != folder.id,
        'bg-indigo-200': _vm.selectedFolder == folder.id
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          _vm.selectedFolder = folder.id;
        }
      }
    }, [_c('div', {
      staticClass: "grid grid-cols-12 items-center h-20 px-6 hover:bg-indigo-200"
    }, [_c('div', {
      staticClass: "col-span-8 flex text-left items-stretch space-x-3"
    }, [_c('icon', {
      staticClass: "h-6 w-7",
      class: {
        'text-indigo-600': folder.color == 'indigo',
        'text-teal-600': folder.color == 'teal',
        'text-orange-600': folder.color == 'orange',
        'text-pink-600': folder.color == 'pink',
        'text-gray-600': folder.color == 'gray'
      },
      attrs: {
        "name": "folder"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "text-lg max-w-7/12 2xl:max-w-full"
    }, [_vm._v("\n                  " + _vm._s(folder.name) + "\n                ")]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.folders.filter(function (f) {
          return f.folder_id == folder.id;
        }).length > 0,
        expression: "\n                    folders.filter((f) => f.folder_id == folder.id).length > 0\n                  "
      }],
      staticClass: "text-base font-light italic text-gray-600 self-center"
    }, [_vm._v("\n                  " + _vm._s(_vm.folders.filter(function (f) {
      return f.folder_id == folder.id;
    }).length) + "\n                  Dossier" + _vm._s(_vm.folders.filter(function (f) {
      return f.folder_id == folder.id;
    }).length > 1 ? 's' : '') + "\n                ")])], 1), _vm._v(" "), _c('list-avatars', {
      staticClass: "col-span-3 mb-1/5 left-18",
      attrs: {
        "size": "w-7 h-7",
        "list-items": folder.users,
        "libelle-firstname": "firstname",
        "libelle-lastname": "lastname"
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.folders.filter(function (f) {
          return f.folder_id == folder.id;
        }).length,
        expression: "\n                  folders.filter((f) => f.folder_id == folder.id).length\n                "
      }],
      staticClass: "col-span-1 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.changeFolder(folder);
        }
      }
    }, [_c('icon', {
      staticClass: "hidden group-hover:block text-pink-600 transform duration-300 hover:scale-125",
      attrs: {
        "name": "chevron-right"
      }
    })], 1)], 1)]);
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "text-red-500 text-sm mt-5"
  }, [_c('p', [_vm._v(_vm._s(((_vm.errors || []).folders || [])[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center space-x-5 mt-5"
  }, [_vm.saving ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-gray-600",
      "bg-color-square": "bg-gray-600",
      "libelle": "Déplacer",
      "uppercase": true,
      "type-shadow": "shadow-gray"
    }
  }) : _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": 'Déplacer' + (_vm.selectedFolder == _vm.currentFolder ? ' ici' : ''),
      "uppercase": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.moveFile();
      }
    }
  })], 1)])]) : _c('div', [_c('div', {
    staticClass: "my-5 mx-20 lg:my-15 lg:mx-36 2xl:my-18 2xl:mx-28 text-center"
  }, [_c('h3', {
    staticClass: "mb-10 text-pink-600"
  }, [_vm._v("\n        Aucun dossier disponible\n      ")]), _vm._v(" "), _c('p', [_vm._v("\n        Veuillez créer un dossier avant de déplacer le " + _vm._s(_vm.filetype) + " « " + _vm._s(_vm.filename) + " ».\n      ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }